import React, { useEffect } from 'react';
import { useState } from 'react';
import ProfileService from '../services/ProfileService';

const UserContext = React.createContext();
const UserConsumer = UserContext.Consumer;

const UserProvider = ({ updateLanguage, children }) => {
  let [user, setUser] = useState(null);
  let [token, setToken] = useState(null);
  const Profile = ProfileService();

  useEffect(() => {
    let jwt = localStorage.getItem('client_token');
    if (jwt !== null) {
      getProfile();
    }
  }, []);

  const getProfile = () => {
    Profile.get()
      .then((res) => {
        if (res && res.success) {
          setUser(res.data);
          updateLanguage({ preventDefault: () => {} }, res.data.languages);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, getProfile, token, setToken, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserProvider, UserConsumer };
